import * as React from 'react';
import { TableGroupRow } from '@devexpress/dx-react-grid-material-ui';

const TableGroupRowCellComponent = (props: TableGroupRow.CellProps) => <TableGroupRow.Cell {...props} className="table-group-row-cell" />;

export { TableGroupRowCellComponent };
